import React, { useState, useRef } from 'react'
import { useSelector } from "react-redux";
import BudgetAllocationList from '../../../components/Multi/BudgetAllocation/BudgetAllocationList';
import { useNavigate } from 'react-router-dom';
import SubHeader from '../../../components/Subheader/Subheader';
import CustomBreadcrumbs from '../../../components/Tools/Breadcumbs';
import CreateButton from '../../../components/Tools/CreateButton';
import MainFilter from '../../../components/Tools/MainFilter';
import DashboardFilter from '../../Dashboard/components/DashboardFilter';
import Spinner from '../../../components/Tools/spinner';


const AllocateListPage = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const { financialYears, authData } = useSelector((state) => state.authData);
    const fy_list = financialYears.payload.fy_list;
    const fyIdRef = useRef(localStorage.getItem('globalDateId'));
    const [filterPayload, setFilterPayload] = useState({
        searchStr: "",
        fromDate: "",
        toDate: "",
        dateColumn: "",
        department_id: "",
        tier: "",
        consolidate: false,
        district_id: "",
        district_name: "",
    });
    const [filterApplied, setFilterApplied] = useState({
            searchStr: "",
            fromDate: "",
            toDate: "",
            dateColumn: "",
            department_id: "",
            tier: "",
            consolidate: false,
            district_id: "",
            district_name: "",
        });
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const handleInput = async (e) => {
        const {name, value} = e.target;
        setFilterPayload((prev) => ({
            ...prev, [name]: value
        }));
    }
    const bootList = async () => {
        setFilterApplied(filterPayload);
        setOpen(false);
    }
    const handleFilterRemove = async (name) => {
        const newPayload = {
        ...filterPayload,
        [name]: "",
        };
        if (name === "district_id") {
            newPayload.district_name = "";
        }
        setFilterPayload(newPayload);
        setFilterApplied(newPayload);
    }

    const handlePageTrigger = () => {
      const newFyId = localStorage.getItem('globalDateId');
      fyIdRef.current = newFyId;
      const financialYear = fy_list.find((e) => e.id == newFyId);
      if (financialYear) {
        const fromDate = `${financialYear.start_year}-04-01`;
        const toDate = `${Number(financialYear.start_year) + 1}-03-31`;
        setFilterApplied((prev) => ({
          ...prev,
          fromDate,
          toDate,
          department_id: "",
        }));
        setFilterPayload((prev) => ({
          ...prev,
          fromDate,
          toDate,
          department_id: "",
        }));
      }
    }

    return (
        <div>
            {loading && <div > <Spinner/> </div>}
            <SubHeader fy_list={fy_list} handlePageTrigger={handlePageTrigger}/>
            <div className='scheme p-3'>
              <div className="row" style={{ padding: "10px 16px" }}>
                  <div className="col-md-6">
                      <h4 style={{ color: "#28326f", margin:0}}>Budget Allocations</h4>
                      <CustomBreadcrumbs linksArray={[]} title="Budget Allocations"/>
                  </div>
                  <div className="col-md-6">
                    <div className="d-flex gap-2" style={{ width: "auto", float: "right" }}>
                        <button type="button" className="navigation_button" onClick={() => navigate("/allocate-budget-approval")}>
                            <span className="fs-14px">Budget Limit Approval & Allotment</span>
                        </button>
                    </div>
                  </div>
              </div>
                <DashboardFilter 
                    openFilterModal={setOpen} 
                    filterPayload={filterApplied} 
                    handleFilterRemove={handleFilterRemove}
                    isTierRemovalRequired={true}
                />
              <BudgetAllocationList fromDate={filterApplied.fromDate} toDate={filterApplied.toDate} searchStr={filterApplied.searchStr} approval={true} tier={filterApplied.tier} departmentId={filterApplied.department_id} districtId={filterApplied.district_id} all={false} setLoading={setLoading}/>


              { authData.user.user_type === 'l1' && <CreateButton title={"Add Budget Allocation"} url={"/allocate-budget"} /> }

                <MainFilter 
                open={open} 
                handleClose={handleClose} 
                handleInput={handleInput} 
                handleOpen={handleOpen} 
                handleFilterClick={bootList} 
                filterPayload={filterPayload}
                setConsolidate={setFilterPayload}
                type="Schemes"/>


            </div>

            

        </div>
    )
}
export default AllocateListPage
